import { Flex, HStack, Icon, Text } from '@chakra-ui/react';
import { Circle } from 'lucide-react';

interface RelationshipToggleProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
}

export const RelationshipToggle = ({
  value,
  onChange,
}: RelationshipToggleProps) => {
  const options: { value: boolean | null; label: string }[] = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
    { value: null, label: 'Either' },
  ];

  return (
    <Flex
      alignItems="center"
      borderBottom="1px solid"
      borderColor="whiteAlpha.100"
      justifyContent="space-between"
      py={5}
    >
      <Text color="whiteAlpha.700">Existing agent/lender relationship</Text>
      <HStack spacing={2}>
        {options.map((option) => {
          const isSelected = value === option.value;

          return (
            <Flex
              key={String(option.value)}
              alignItems="center"
              bg={isSelected ? 'white' : 'whiteAlpha.50'}
              border="1px solid"
              borderColor="whiteAlpha.100"
              borderRadius="sm"
              cursor="pointer"
              gap={4}
              px={3}
              py={2}
              transition="all 0.2s"
              onClick={() => onChange(option.value)}
            >
              <Text
                color={isSelected ? 'indigo.900' : 'white'}
                fontSize="sm"
                fontWeight="medium"
              >
                {option.label}
              </Text>
              <Icon
                as={Circle}
                boxSize={4}
                color={isSelected ? 'indigo.900' : 'whiteAlpha.400'}
                fill={isSelected ? 'indigo.900' : 'transparent'}
              />
            </Flex>
          );
        })}
      </HStack>
    </Flex>
  );
};
